export default "__VITE_ASSET__BlsFc9l___"